import createHistory from 'history/createBrowserHistory';
/**
 * @description refeshPage: Refresh The Page On Click
 */
function refreshPage()
{
  window.location.reload();
}
/**
 * @description  EnnsRedirect: Redirects The User To The Enns Brothers Website And Then Routes The User Back To The Home Page
 * @export  EnnsRedirect
 * @returns {*}  
 */
export default function LinkToEnvCanadaAPI() {
  const history = createHistory();
  return (
    window.open( 'https://openweathermap.org/' ),
    history.push( '' ),
    refreshPage()
  );
}